import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import { documentStore } from './components/DocumentStore';
import { EDITOR_IMPORT_KEY } from '../textCleaner/textCleanerTransfer';
import MenuBar from './components/MenuBar';
import MenuIconBar from './components/MenuIconBar';
import TabBar from './components/TabBar';
import Editor from './components/Editor';
import StatusBar from './components/StatusBar';
import './styles/textEditor.css';

const TextEditor = observer(() => {
  const fileInputRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/texteditor') return;
    try {
      const raw = sessionStorage.getItem(EDITOR_IMPORT_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      sessionStorage.removeItem(EDITOR_IMPORT_KEY);
      if (parsed && typeof parsed.content === 'string' && parsed.content.length > 0) {
        documentStore.importFromTextCleaner(parsed.content);
      }
    } catch (_) {
      /* ignore */
    }
  }, [location.pathname, location.key]);

  const {
    documents,
    activeDocumentIndex,
    setActiveDocumentIndex,
    updateDocumentContent,
    addDocument,
    saveDocument,
    handlePrint,
    handleFileChange,
    onCloseTab,
    renameDocument,
  } = documentStore;

  const activeDocument = documents[activeDocumentIndex];

  return (
    <div className="te-module">
      <div className="te-card">
        <MenuBar
          onAddDocument={documentStore.addDocument}
          onOpenDocument={() => fileInputRef.current.click()}
          onSaveDocument={documentStore.saveDocument}
          onPrint={documentStore.handlePrint}
          onCapitalize={() => documentStore.transformText('capitalize')}
          onLowercase={() => documentStore.transformText('lowercase')}
          onUppercase={() => documentStore.transformText('uppercase')}
          onInverseWord={() => documentStore.transformText('inverseWord')}
          onInverseCharacters={() => documentStore.transformText('inverseCharacters')}
          onWordWrap={() => documentStore.WordWrap(80)}
          onLanguageSelect={documentStore.updateDocumentLanguage}
        />

        <MenuIconBar
          onAddDocument={addDocument}
          onOpenDocument={() => fileInputRef.current.click()}
          onSaveDocument={saveDocument}
          onPrint={handlePrint}
          onCapitalize={() => documentStore.transformText('capitalize')}
          onLowercase={() => documentStore.transformText('lowercase')}
          onUppercase={() => documentStore.transformText('uppercase')}
          onInverseWord={() => documentStore.transformText('inverseWord')}
          onInverseCharacters={() => documentStore.transformText('inverseCharacters')}
          onWordWrap={() => documentStore.WordWrap(80)}
        />

        <TabBar
          documents={documentStore.documents}
          activeIndex={documentStore.activeDocumentIndex}
          documentStore={documentStore}
          onSetActive={setActiveDocumentIndex}
          onCloseTab={onCloseTab}
          onRenameTab={renameDocument}
        />

        <div className="te-editor-area">
          {documents.length > 0 && activeDocument && (
            <Editor
              key={activeDocument.id}
              onChange={(newContent) => updateDocumentContent(newContent)}
              language={activeDocument.language}
              content={activeDocument.content}
            />
          )}
        </div>

        <StatusBar
          content={activeDocument ? activeDocument.content : ''}
          language={activeDocument ? activeDocument.language : 'Text'}
        />
      </div>

      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </div>
  );
});

export default TextEditor;
